import React, {
  CSSProperties, PropsWithChildren,
  useEffect, useLayoutEffect, useMemo, useRef,
  forwardRef, useImperativeHandle,
} from 'react';
import { omit } from 'lodash';
import './index.css';

const defaultClassName = 'custom-mach-textarea';
const disableClassName = 'custom-mach-textarea-disabled';

export default forwardRef((props: PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
  focus?: boolean;
  onClick?: (e?: any) => void;
  onInput?: (e?: any) => void;
  onChange?: (e?: any) => void;
  onFocus?: (e?: any) => void;
  onBlur?: (e?: any) => void;
  onConfirm?: (e?: any) => void;
  keyboardAvoid?: boolean;
}>, ref) => {
  const {
    className,
    style,
    value,
    placeholder,
    disabled,
    maxLength,
    focus,
    onClick,
    onInput,
    onChange,
    onFocus,
    onBlur,
    onConfirm,
    keyboardAvoid,
    rows = 3,
    ...otherProps
  } = props;
  const textAreaProps = omit(otherProps, [
    'adjustPosition',
    'confirmType',
    'placeholderColor',
    'cursorColor',
    'onKeyboardHeightChanged',
  ]);
  const inputRef = useRef(null);

  const distCls = useMemo(() => {
    let _distCls = 'custom-mach-textarea';
    if (className) {
      _distCls = `${_distCls} ${className}`;
    }
    if (disabled) {
      _distCls = `${_distCls} custom-mach-textarea-disabled`;
    }
    return _distCls;
  }, [className, disabled]);

  useImperativeHandle(ref, () => ({
    value: () => inputRef.current?.value,
    setValue: (val) => {
      console.log('ttttt', inputRef.current?.value);
      console.log(val, 'textarea val');
    },
    blur: () => {
      inputRef.current?.blur();
    },
  }));

  useLayoutEffect(() => {
    if (!inputRef.current) return;
    const inputDom = inputRef.current;
    if (focus) {
      inputDom?.focus();
    }
    function handler(e) {
      if (e?.keyCode !== 13) return;
      onConfirm && onConfirm({
        detail: e.target.value,
        type: 'confirm',
        bubbles: false,
        cancelable: false,
        timeStamp: Date.now(),
        e,
      });
      e?.target?.blur && e.target.blur();
    }
    inputDom?.addEventListener('keydown', handler);

    return () => {
      inputDom?.removeEventListener('keydown', handler);
    };
  // }, [focus, onConfirm]);
  }, [focus, onConfirm]);

  function handleInput(e) {
    const newValue = e?.target?.value;
    const timeStamp = Date.now();
    const type = 'change';

    onInput && onInput({
      detail: newValue,
      type,
      bubbles: false,
      cancelable: false,
      timeStamp,
      e,
    });
    onChange && onChange({
      detail: newValue,
      type,
      bubbles: false,
      cancelable: false,
      timeStamp,
      e,
    });
  }

  // 必须多一层包裹，增加onClick={handleClick}，来拦截点击冒泡到上层（上层有点击来失焦的处理）导致输入框失焦无法输入
  function handleClick(e) {
    console.log('ttttt click', e.target?.value);
    onClick && onClick(e);
    // e.preventDefault(); // 此处响应了，自动不会再冒泡上去了
    // e.stopPropagation();
  }

  function handleFocus(e) {
    console.log('ttttt onFocus', e.target?.value);
    // e.preventDefault();
    // e.stopPropagation();
    onFocus && onFocus(e);
  }

  // console.log(disabled, 'disabled', textAreaProps);
  return (
    <machweb-view className="custom-mach-textarea-w" onClick={handleClick}>
      <textarea
        // autoFocus={focus}
        value={value}
        placeholder={placeholder}
        disabled={!!disabled}
        className={distCls}
        maxLength={maxLength === -1 ? undefined : maxLength}
        style={style}
        inner
        rows={rows}
        ref={inputRef}
        // onClick={handleClick}
        onFocus={handleFocus}
        onBlur={onBlur}
        onInput={handleInput}
        {...textAreaProps}
      />
    </machweb-view>
  );
});
